module.exports = __webpack_public_path__ + "img/compartidos.2ff0eac6.svg";